export { FourUp } from './FourUp'
export type { OriginalPostDataProps } from './FourUp'
